import React from 'react'
import { Row, Cell, useContainerWidth, Separator } from '@fs/zion-ui'
import { useTranslation } from 'react-i18next'
import TagLine from './TagLine'
import FooterSocial from './FooterSocial'
import FSLogo from './FSLogo'

export default function SocialSection(props) {
  const atWidth = useContainerWidth()
  const { t } = useTranslation()

  return (
    <nav aria-label={t('nav.footer-social', 'Branding and social media links')}>
      <Row
        guttersX="xl"
        alignX={atWidth({ default: 'center', xs: 'start' })}
        wrap={atWidth({ default: true, xs: false })}
      >
        <Cell growX={atWidth({ xs: true })}>
          <FSLogo />
          <Separator size={atWidth({ default: 'hide', xs: 'nano' })} />
          <TagLine {...props} />
          <Separator size="xs" />
        </Cell>
        <FooterSocial noShrinkX centered={atWidth({ default: true, xs: false })} />
      </Row>
    </nav>
  )
}
